import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { reportError } from '@/monitoring';

/**
 * Écran d'erreur à la place de la page blanche (T4) : un écran qui plante affiche un message et un bouton pour
 * recharger ; l'erreur part chez Sentry quand il est actif.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    reportError(error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" data-testid="error-screen"
        style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: 'var(--bg, #f8f7f4)' }}>
        <div style={{ maxWidth: 420, textAlign: 'center' }}>
          <AlertTriangle size={40} color="var(--gold, #c9a227)" aria-hidden="true" />
          <h1 style={{ fontFamily: 'var(--f-display)', fontSize: 22, margin: '16px 0 8px' }}>Une erreur est survenue</h1>
          <p style={{ fontSize: 14, color: 'var(--ink2, #475569)', marginBottom: 20 }}>
            Cette page n’a pas pu s’afficher. L’équipe Colis2Ship a été prévenue. Rechargez la page pour réessayer.
          </p>
          <button type="button" className="btn btn-teal" onClick={() => window.location.reload()} data-testid="error-screen-reload">
            <RotateCcw size={16} aria-hidden="true" /> Recharger la page
          </button>
        </div>
      </div>
    );
  }
}
